import { FC } from 'react';
import { useHasAnyPermission } from '@/entities/profile';
import { RouteConfig } from '@/shared/lib';
import { Icon, IconType, SidebarNavItem } from '@/shared/ui';
import { useIsActive } from '@/widgets/MainLayout/model/hooks/useIsActive';
import { AppSidebarLabel } from './AppSidebarLabel';

type Props = {
  route: RouteConfig;
  className?: string;
};

export const AppSidebarItem: FC<Props> = (props) => {
  const { route, className } = props;

  const { isActive } = useIsActive(route);

  const allowView = useHasAnyPermission([route.viewPermission]);

  if (!allowView) {
    return null;
  }

  return (
    <SidebarNavItem
      path={route.navbar?.path || route.path!}
      isActive={isActive}
      className={className}
      icon={
        typeof route.navbar?.icon === 'string' ? (
          <Icon type={route.navbar?.icon as IconType} width={16} className={'text-muted-foreground'} />
        ) : (
          route.navbar?.icon
        )
      }
      label={<AppSidebarLabel label={route.label} />}
      endSlot={
        route.navbar?.badge && (
          <span className="ml-auto text-[10px] shrink-0 font-medium px-1.5 py-0.5 rounded bg-blue-200 text-blue-600 dark:bg-blue-200 dark:text-blue-400">
            {route.navbar.badge}
          </span>
        )
      }
    />
  );
};
